import React, { useRef } from 'react';
import Bookmark from '../models/Bookmark';

const FileUploader = ({ onFileParsed }) => {
    const fileInputRef = useRef(null);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const bookmarks = parseHtml(e.target.result);
                    onFileParsed(bookmarks);
                } catch (error) {
                    console.error('Error parsing bookmarks:', error);
                }
            };
            reader.readAsText(file);
        }
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const parseHtml = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const bookmarkElements = doc.getElementsByTagName('a');
        const bookmarks = [];

        for (let element of bookmarkElements) {
            const bookmark = new Bookmark(
                element.textContent,
                element.href,
                element.getAttribute('tags')?.split(',') || [],
                element.getAttribute('add_date') 
                    ? new Date(parseInt(element.getAttribute('add_date')) * 1000).toISOString().split('T')[0]
                    : new Date().toISOString().split('T')[0]
            );
            bookmarks.push(bookmark);
        }

        return bookmarks;
    };

    return (
        <div className="relative">
            <input
                type="file"
                accept=".html"
                onChange={handleFileUpload}
                ref={fileInputRef}
                className="hidden"
            />
            <button
                onClick={handleClick}
                className="flex items-center gap-2 bg-indigo-600 text-white rounded-lg px-4 py-2 hover:bg-indigo-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
            >
                <i className="fas fa-file-upload"></i>
                <span>Import Bookmarks</span>
            </button>
            <p className="text-xs text-indigo-600 mt-1">
                Supports HTML bookmark files
            </p>
        </div>
    );
};

export default FileUploader; 